/* eslint-disable react/jsx-no-target-blank */
import { Fragment } from "react";
import { useIntl } from "react-intl";

import { AsideMenuItemWithSub } from "./AsideMenuItemWithSub";
import { AsideMenuItem } from "./AsideMenuItem";
import { checkPathRequirement } from "../../../../app/routing/RouteRequirementHandler";
import { useAuth } from "../../../../app/utils/useAuth";
import { menusList } from "./menuList";

export function AsideMenuMain() {
    const intl = useIntl();
    const { currentUser } = useAuth();

    return (
        <>
            <AsideMenuItem
                to="/dashboard"
                icon="/media/icons/duotune/layouts/lay002.svg"
                title={intl.formatMessage({ id: "menu.dashboard" })}
            />

            {menusList.map((menu, menuIndex) => (
                <Fragment key={menuIndex}>
                    {checkPathRequirement(menu.url, currentUser?.role) && (
                        <>
                            <div className="menu-item">
                                <div className="menu-content">
                                    <div className="separator mx-1 my-4"></div>
                                </div>
                            </div>
                            <div className="menu-item">
                                <div className="menu-content pb-2">
                                    <span className="menu-section text-muted text-uppercase fs-8 ls-1 fw-bold">
                                        {intl.formatMessage({ id: `menu.title.${menu.title}` })}
                                    </span>
                                </div>
                            </div>

                            <>
                                {menu.subMenus.map((submenu, subIndex) => (
                                    <Fragment key={subIndex}>
                                        {checkPathRequirement(submenu.url, currentUser?.role) && (
                                            <>
                                                {submenu.folderMenus ? (
                                                    <AsideMenuItemWithSub
                                                        to={submenu.title}
                                                        title={intl.formatMessage({
                                                            id: submenu.title,
                                                        })}
                                                        icon={submenu.icon}
                                                    >
                                                        {submenu.folderMenus.map(
                                                            (folderMenu, folderIndex) => (
                                                                <Fragment key={folderIndex}>
                                                                    {checkPathRequirement(
                                                                        folderMenu.url,
                                                                        currentUser?.role
                                                                    ) && (
                                                                        <AsideMenuItem
                                                                            to={folderMenu.url}
                                                                            title={intl.formatMessage(
                                                                                {
                                                                                    id: folderMenu.title,
                                                                                }
                                                                            )}
                                                                            hasBullet={true}
                                                                        />
                                                                    )}
                                                                </Fragment>
                                                            )
                                                        )}
                                                    </AsideMenuItemWithSub>
                                                ) : (
                                                    <>
                                                        {checkPathRequirement(
                                                            submenu.url,
                                                            currentUser?.role
                                                        ) && (
                                                            <AsideMenuItem
                                                                to={submenu.url}
                                                                icon={submenu.icon}
                                                                title={intl.formatMessage({
                                                                    id: submenu.title,
                                                                })}
                                                            />
                                                        )}
                                                    </>
                                                )}
                                            </>
                                        )}
                                    </Fragment>
                                ))}
                            </>
                        </>
                    )}
                </Fragment>
            ))}
        </>
    );
}
